import { useEffect, useRef, useState } from 'react';
import { TDataDogContext } from '@mindtickle/ui-shell-core/DatadogProvider';
import { COMMON_TAGS } from '../config/constants';
import { updateShellContext } from '@mindtickle/ui-shell-core/Datadog';

const useResourceFetchedType = (
  datadog: TDataDogContext,
  appNameVal: string,
  updateContext: Function
) => {
  const buildVer = datadog && datadog.appBuildVer ? datadog.appBuildVer : '';
  const appNameRef: any = useRef(null);
  const buildVerRef: any = useRef(null);
  const [initializeContext, shouldInitialize] = useState(false);

  const initializeResourceFetchFn = () => shouldInitialize(true);

  /* eslint-disable-next-line complexity,max-statements */
  const remoteInitializedCallback = () => {
    try {
      if (!initializeContext || !appNameVal || !buildVer) {
        return;
      }
      let fetchedFromServer = true;
      const mtBuildVer: string | null = localStorage.getItem(COMMON_TAGS.BUILD_VER_MAP);
      let mtBuildVerObj: Record<string, string> = {};
      const { pathname } = window.location;
      const pathWithoutDigits: string = pathname.replace(/\d/g, '');
      if (mtBuildVer) {
        mtBuildVerObj = JSON.parse(mtBuildVer) || mtBuildVerObj;
      }

      if (mtBuildVerObj[pathWithoutDigits] && mtBuildVerObj[pathWithoutDigits] === buildVer) {
        fetchedFromServer = false;
      }

      mtBuildVerObj[pathWithoutDigits] = buildVer;
      localStorage.setItem(COMMON_TAGS.BUILD_VER_MAP, JSON.stringify(mtBuildVerObj));
      updateShellContext(COMMON_TAGS.FETCHED_FROM_SERVER, fetchedFromServer);
      // set the Apps build version in window object
      window.MTAppBuildVer = window.MTAppBuildVer || {};
      window.MTAppBuildVer[appNameVal] = buildVer;
    } catch (e) {
      // console.error(e);
    }
  };
  useEffect(
    // eslint-disable-next-line complexity
    () => {
      if (
        (appNameVal && appNameVal !== appNameRef.current) ||
        (datadog && datadog.appBuildVer !== buildVerRef.current)
      ) {
        remoteInitializedCallback();
      }
      buildVerRef.current = datadog && datadog.appBuildVer ? datadog.appBuildVer : '';
      appNameRef.current = appNameVal;
    },
    [datadog, appNameVal, initializeContext]
  );

  return { initializeResourceFetchFn };
};

export default useResourceFetchedType;
